import type { ColumnDef, Table } from '@tanstack/react-table';
import { Checkbox } from '@/components/ui/checkbox';

export function getSelectionColumn<T>(): ColumnDef<T> {
  return {
    id: 'select',
    size: 40,
    minSize: 40,
    maxSize: 40,
    enableHiding: false,
    enableSorting: false,
    header: ({ table }: { table: Table<T> }) => (
      <div
        className="flex items-center justify-center -mx-4 -my-3 px-4 py-3 cursor-pointer"
        onClick={() => table.toggleAllPageRowsSelected(!table.getIsAllPageRowsSelected())}
      >
        <Checkbox
          aria-label="Select all"
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && 'indeterminate')
          }
          tabIndex={-1}
          className="pointer-events-none"
        />
      </div>
    ),
    cell: ({ row }) => (
      <div
        className="flex items-center justify-center -mx-4 -my-3 px-4 py-3 cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          row.toggleSelected(!row.getIsSelected());
        }}
      >
        <Checkbox
          aria-label="Select row"
          checked={row.getIsSelected()}
          tabIndex={-1}
          className="pointer-events-none"
        />
      </div>
    ),
  };
}
